import { ReactNode } from "react";
import DSBox from "views/system-design/DSBox";

/**
 * Greys out and blocks everything inside when `locked`. The settings
 * sections are a mix of older widgets without a disabled prop, so this
 * blocks pointer and keyboard input at the wrapper instead.
 */
const LockedSection = ({
  locked,
  children,
}: {
  locked: boolean;
  children: ReactNode;
}) =>
  locked ? (
    <DSBox
      aria-disabled
      // inert: no focus or keyboard input inside, on top of no clicks.
      {...{ inert: "" }}
      sx={{
        pointerEvents: "none",
        userSelect: "none",
        opacity: 0.55,
        filter: "grayscale(0.4)",
      }}
    >
      {children}
    </DSBox>
  ) : (
    <>{children}</>
  );

export default LockedSection;
